import { Box, Button, Container, Typography, useMediaQuery } from "@mui/material";
import plano_coletivo from "../../../../assets/images/planos/plano-coletivo.jpg";
import { styleImage, styleTitle } from ".";
const Coletivo: React.FC<{ setPlanoAtual(newValue: string): void }> = ({ setPlanoAtual }) => {

  const isMobile = useMediaQuery("(max-width:768px)");

  return (
    <Box bgcolor={"#e7e7e7"} p={isMobile ? 0 : 2} pb={1}>
      <Container 
        style={{
            display:"flex" ,
            alignItems:"center" ,
            justifyContent:"space-between",
            flexDirection: isMobile ? "column" :"row"
        }}
      >
        {
          isMobile ?  (
          <Box 
            flex={1} 
            height="300px" 
            width="100%"
            bgcolor="#e0e0e0" 
            display="flex" 
            alignItems="center" 
            justifyContent="center"
            borderRadius="8px"
          > <img style={styleImage} src={plano_coletivo} />
          </Box> 
          ): null
        }
        {/* Texto */}
        <Box flex={1} mr={isMobile ? 0 : 4}>
          <Typography variant={ isMobile ? "h6" : "h5" } style={styleTitle} fontWeight="bold">
            Plano coletivo por adesão Innova
          </Typography>
          <Typography variant="body1" color="textSecondary" mt={2} textAlign="justify">
            Saúde e proteção acessíveis para profissionais e grupos unidos por uma vida 
            melhor:
          </Typography>
          <Typography variant="body1" color="textSecondary" mt={2} textAlign="justify">
            Feito para grupos profissionais e sindicatos 
            Benefícios completos, similares aos empresariais 
            Planos acessíveis, com atendimento de qualidade 
            Ampla rede referenciada e programas de saúde.
          </Typography>
          <Box mt={3} display="flex" justifyContent={ isMobile ? "center" : "flex-start"}>
            <Button variant="contained" color="warning" onClick={() => setPlanoAtual("coletivo")}>
              FALE COM A GENTE
            </Button>
          </Box>
        </Box>
        {
          !isMobile ?  (
          <Box 
            flex={1} 
            height="300px" 
            width="600px"
            bgcolor="#e0e0e0" 
            display="flex" 
            alignItems="center" 
            justifyContent="center"
            borderRadius="8px"
          >

            <img style={styleImage} src={plano_coletivo} />
          </Box> 
          ): null
        }
  
      </Container>
    </Box>
  )
}
export default Coletivo;